import { useForgotPasswordMutation } from '@services/core/auth/auth.endpoints';
import { ForgotPasswordRequest } from '@services/core/auth/auth.types';
import { useEffect, useState } from 'react';

export const useForgotPasswordPageVM = () => {
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [forgotPassword, { isLoading, isSuccess, data, isError, error }] = useForgotPasswordMutation();

    const handleSubmit = async (values: ForgotPasswordRequest) => {
        forgotPassword({ email: values.email });
    };

    useEffect(() => {
        if (isError && error) {
            console.log('error', error);
            return;
        }
        if (isSuccess && data) {
            setIsEmailSent(true);
            return;
        }
    }, [isSuccess, isError]);

    return {
        handleSubmit,
        isLoading,
        isEmailSent
    };
};
